// Preferência de ABERTO/FECHADO das seções do menu (A-6) — pura.
//
// ★★★ A REGRA DO DONO, em duas metades:
//
//   1. a seção abre SOZINHA quando a página atual está dentro dela;
//   2. senão, ela lembra a última escolha da pessoa.
//
// ⚠⚠ A ordem importa e é a parte fácil de errar: se a lembrança viesse primeiro,
// alguém que fechou "Remuneração" e depois abrisse `/recebimentos` pelo histórico
// do navegador cairia numa tela cujo item do menu está escondido — sem pista de
// onde está. ★ A rota vence a lembrança, sempre.
//
// ★ POR QUE `localStorage` AQUI, se `lib/estadoDeSessao.js` o proíbe: o que ele
// proíbe é DADO DE PACIENTE (regra de LGPD do projeto). Qual seção está aberta é
// preferência de tela, igual à visão da agenda (`agenda/preferencias.js`), às
// seções da inbox e ao som de notificação — e este módulo segue o mesmo padrão.
//
// ★★ A CHAVE LEVA O UID, pelo mesmo motivo da agenda: o computador da recepção é
// COMPARTILHADO, e a escolha de quem entrou de manhã não pode valer para quem
// entrar à tarde.
//
// ⚠ Todo acesso em `try/catch`: só TOCAR em `globalThis.localStorage` já lança em
// navegador com cookies de terceiros bloqueados, e uma preferência de menu nunca
// pode derrubar o app inteiro.

/** ★ O nome da única seção de hoje. Exportado para o menu e os testes concordarem. */
export const SECAO_REMUNERACAO = 'Remuneração';

/**
 * ★ Fechada por padrão.
 *
 * ⚠ O menu do gestor tem 11 itens soltos; abrir a seção por padrão somaria 5 e
 * voltaria a passar da altura da tela — que é o problema que a E4 mediu
 * ("15 itens numa lista plana"). ★ Quem precisa dela abre uma vez, e a escolha
 * fica.
 */
export const SECAO_ABERTA_PADRAO = false;

export const chaveDaSecao = (uid, secao) =>
  `odontosdr:menu-secao:${secao}:${uid ?? 'anonimo'}`;

function deposito() {
  try {
    return globalThis.localStorage ?? null;
  } catch {
    return null;
  }
}

/** A escolha guardada, ou o padrão. ⚠ Valor desconhecido NÃO passa. */
export function carregarSecao(uid, secao, armazem = deposito()) {
  try {
    const cru = armazem?.getItem(chaveDaSecao(uid, secao));
    if (cru === 'aberta') return true;
    if (cru === 'fechada') return false;
    return SECAO_ABERTA_PADRAO;
  } catch {
    return SECAO_ABERTA_PADRAO;
  }
}

/**
 * Guarda a escolha. Devolve `true` se gravou.
 *
 * ⚠ Sem depósito NÃO é sucesso — a mesma lição do `salvarVisao` da agenda: um
 * valor de retorno que mente é pior que nenhum.
 */
export function salvarSecao(uid, secao, aberta, armazem = deposito()) {
  if (!armazem) return false;
  try {
    armazem.setItem(chaveDaSecao(uid, secao), aberta ? 'aberta' : 'fechada');
    return true;
  } catch {
    return false;
  }
}

/**
 * ★★★ A DECISÃO FINAL de abrir ou não, com a precedência escrita.
 *
 * `naSecao` é "a página atual é de um item desta seção?" — quem chama já sabe,
 * porque é ele que tem a rota e a lista de itens.
 *
 * ★ Pura de propósito: dá para testar a precedência inteira sem navegador e sem
 * `localStorage`.
 */
export function secaoDeveAbrir(uid, secao, naSecao, armazem = deposito()) {
  if (naSecao) return true;
  return carregarSecao(uid, secao, armazem);
}
